import React from 'react';
import PropTypes from 'prop-types';

import Header from './components/header';
import Footer from './components/footer';

export default function Modal({
  children,
  show = false,
  overlay = false,
  width = 'auto',
  height = 'auto',
  enableButtons = false,
  closeCb,
  confirmCb,
  title = 'Confirmar?',
}) {
  if (show) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: overlay ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            width,
            minWidth: 350,
            height,
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            borderRadius: 8,
          }}
        >
          <Header title={title} closeCb={closeCb} />
          <div
            style={{
              width: '100%',
              height: '100%',
              boxSizing: 'border-box',
              padding: '10px',
            }}
          >
            {children}
          </div>
          <Footer
            confirmCb={confirmCb}
            closeCb={closeCb}
            enableButtons={enableButtons}
          />
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired,
  overlay: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  enableButtons: PropTypes.bool,
  closeCb: PropTypes.func.isRequired,
  confirmCb: PropTypes.func,
  title: PropTypes.string,
};
